import { BrandType } from "@/api-schema-enums";
import i18next from "i18next";

export function renderBrandType(type: BrandType): string {
  const brandTranslations: Record<BrandType, string> = {
    Franchised_Oem: i18next.t("masterdata:FranchisedOEM"),
    Non_Franchised_Oem: i18next.t("masterdata:NonFranchisedOEM"),
    Owned: i18next.t("masterdata:OwnedBrand"),
    Other: i18next.t("masterdata:Other"),
  };

  return brandTranslations[type] ?? i18next.t("masterdata:UnknownType", { type });
}
